import React, { useEffect, useRef } from "react";

const SplitText = ({
  text,
  className = "",
  delay = 0,
  staggerMs = 28,
  as: Tag = "span",
  triggerOnMount = false,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const chars = el.querySelectorAll(".split-char");

    const reveal = () => {
      chars.forEach((c, i) => {
        setTimeout(() => c.classList.add("is-in"), delay + i * staggerMs);
      });
    };

    if (triggerOnMount) {
      reveal();
      return;
    }

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            reveal();
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay, staggerMs, triggerOnMount, text]);

  const render = (str) => {
    return str.split("").map((ch, i) => (
      <span key={i} className="split-char" style={{ display: "inline-block" }}>
        {ch === " " ? " " : ch}
      </span>
    ));
  };

  if (Array.isArray(text)) {
    return (
      <Tag ref={ref} className={className} aria-label={text.join(" ")}>
        {text.map((segment, i) => (
          <span key={i} className={segment.className || ""}>
            {render(segment.text)}
          </span>
        ))}
      </Tag>
    );
  }

  return (
    <Tag ref={ref} className={className} aria-label={text}>
      {render(text)}
    </Tag>
  );
};

export default SplitText;
